import React from 'react';
import { Modal } from 'antd';

import Button from 'components/Button';
import DF from 'DisplayFramework';
import { BrokerForProposalType } from './BrokerInput';
import BrokerDetail from 'pages/Configuration/ManagementCompany/BrokerDetail';

type BrokerModalProps = {
  onCancel: () => void;
  tpidbroker?: number;
  visible: boolean;
  title: string;
  onSuccess?: () => void;
  isProposalCreate?: boolean;
  iscreate?: boolean;
  setBrokerForProposal?: (BrokerForProposal: BrokerForProposalType) => void;
  hideBrokerModal?: () => void;
  hideBrokerSearchModal?: () => void;
  associd?:number;
};

const BrokerModal = (props: BrokerModalProps) => {
  const {
    onCancel,
    visible,
    title,
    iscreate,
    setBrokerForProposal,
    hideBrokerModal,
    hideBrokerSearchModal,
    associd
  } = props;

  return (
    <DF.Provider pagcode="proplist">
      <Modal
        visible={visible}
        onCancel={onCancel}
        width={1400}
        title={title}
        footer={[<Button key="cancel" comcode="cancel" onClick={onCancel} />]}
      >
        <BrokerDetail
          brokerMgid={Number(localStorage.getItem('mgid'))}
          setBrokerForProposal={setBrokerForProposal}
          hideBrokerModal={hideBrokerModal}
          hideBrokerSearchModal={hideBrokerSearchModal}
          isCreate={iscreate} 
          associdbroker={associd}  
          showAsModal     
        />
        
      </Modal>
    </DF.Provider>
  );
};

export default BrokerModal;
